import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-email-success-page',
  templateUrl: './change-email-success-page.component.html',
  styleUrls: ['./change-email-success-page.component.scss']
})
export class ChangeEmailSuccessPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
